import {Routes} from '@angular/router';
import {NotificationSettingsComponent} from './notification-settings/notification-settings.component';

export const nativeSettingsRouting: Routes = [
  {
    path: 'notifications',
    component: NotificationSettingsComponent,
  },
];
